export const brand = 'The Blues Teacher’s Arsenal™'

export const checkoutUrl = 'https://the-blues-master.impultienda.ar/checkout'

export const priceValue = 27
export const priceLabel = '$27'
export const realValueLabel = '$707'
export const savingsLabel = 'You save $680 — 96% discount'
export const localCurrencyNote = 'You’ll pay in your local currency.'

export const heroMockup =
  'https://cdn.magicpatterns.com/uploads/rN4mSfWXEtSZsGFFfYh8es/ChatGPT_Image_26_ago_2026,_11_33_11_a.m..png'

export const heroBullets = [
  '6 complete volumes',
  '5 strategic bonuses',
  '300+ ready-to-use sessions',
  '120+ visual reference cards',
  'Beginner to performance level',
]

export const trustMicroCopy = ['Secure payment', 'Instant access', '7-day money-back guarantee']

export const socialProof = [
  { stat: '2,500+', label: 'Blues educators across USA, UK, Canada & Australia' },
  { stat: '6 + 5', label: 'Volumes and bonuses included' },
  { stat: '4.9/5', label: 'Community rating from professional teachers' },
  { stat: 'Every week', label: 'New backing tracks & resources added' },
  { stat: 'Foundation → Stage', label: 'Stage-ready coverage end to end' },
]

export const testimonials = [
  {
    quote:
      'I planned my entire teaching year in one evening. Every lesson now has a clear objective, and my students are actually seeing progress they can hear.',
    name: 'Julian R.',
    role: 'Blues Instructor',
    city: 'London',
  },
  {
    quote:
      'I no longer spend my Sunday nights writing out tabs or searching for tracks. I open the Arsenal and everything is there: organized and professional.',
    name: 'Mark S.',
    role: 'Private Studio Owner',
    city: 'Austin',
  },
]

export const painPoints = [
  'You spend 3+ hours every week scavenging for tabs and backing tracks.',
  'You run out of licks to teach and end up repeating the same old patterns.',
  'Your students struggle to improvise because they lack a logical progression.',
  'Student retention is low because they don’t see a clear path to the stage.',
  'You feel stressed and “phoning it in” before your afternoon sessions.',
  'You’re trading your passion for playing for administrative burnout.',
]

export const systemMetrics = [
  { value: '240+', label: 'Practical pages' },
  { value: '300+', label: 'Ready-to-use sessions' },
  { value: '120+', label: 'Visual reference cards' },
  { value: '6', label: 'Complete volumes' },
]

export const levels = [
  { number: '01', title: 'The 12-Bar Foundation' },
  { number: '02', title: 'Pentatonic & Scale Mastery' },
  { number: '03', title: 'Phrasing, Bending & Dynamics' },
  { number: '04', title: 'Chicago, Delta & Texas Styles' },
  { number: '05', title: 'Improvisation & Solo Building' },
  { number: '06', title: 'Assessment & Stage Readiness' },
]

export type VolumeIcon =
  | 'rhythm'
  | 'fretboard'
  | 'expression'
  | 'styles'
  | 'cards'
  | 'planner'

export const volumes: {
  number: string
  title: string
  description: string
  tags: string[]
  icon: VolumeIcon
}[] = [
  {
    number: '01',
    title: 'The Rhythm Architecture Vault',
    description:
      '50 complete sessions on shuffle feels, dominant 7th voicings, and the “DNA” of the 12-bar blues.',
    tags: ['Shuffle Feel', 'Chord Voicings', 'Turnarounds', 'Timing Drills'],
    icon: 'rhythm',
  },
  {
    number: '02',
    title: 'Pentatonic & Fretboard Freedom',
    description:
      'Total mastery of the 5 positions, connecting boxes, and the secret to targeting chord tones in every key.',
    tags: ['5 Boxes', 'Chord Tones', 'Scale Sequencing', 'Speed Drills'],
    icon: 'fretboard',
  },
  {
    number: '03',
    title: 'The Expression & Phrasing Manual',
    description:
      'Detailed guides on mastering the “singing” quality of Blues: bending, vibrato, and the power of silence.',
    tags: ['Intonation', 'Expression', 'Dynamics', 'Breathing Space'],
    icon: 'expression',
  },
  {
    number: '04',
    title: 'The Regional Styles Encyclopedia',
    description:
      '50 sessions mapped out to teach the nuances of Chicago, Delta, Texas, and Modern Blues styles.',
    tags: ['Muddy Waters', 'Robert Johnson', 'SRV', 'BB King'],
    icon: 'styles',
  },
  {
    number: '05',
    title: 'Visual Cue Cards & Lick Library',
    description:
      '120+ visual reference cards to explain techniques and demonstrate licks instantly without picking up a pen.',
    tags: ['120+ Lick Cards', 'Technique Charts', 'Visual Aids'],
    icon: 'cards',
  },
  {
    number: '06',
    title: 'The Ultimate Lesson Planner',
    description:
      'A complete 52-week calendar with every lesson mapped out, including monthly teaching objectives.',
    tags: ['52-Week Map', 'Unit Goals', 'Checkpoints', 'Student Reports'],
    icon: 'planner',
  },
]

export const bonuses = [
  {
    number: '01',
    title: 'The Blues Class Starter Kit',
    description: 'Everything you need to run a confident first blues lesson from day one.',
    value: '$50',
    image: 'https://cdn.magicpatterns.com/uploads/cnFuYNxkCrZ5BKL6ft3b8M/blues_1.webp',
  },
  {
    number: '02',
    title: 'The 10-Minute Blues Warm-Up Library',
    description: 'Short, focused warm-ups that get hands and ears ready in every session.',
    value: '$50',
    image: 'https://cdn.magicpatterns.com/uploads/c3R4ybfb58qqmc94tPTbiM/blues_2.webp',
  },
  {
    number: '03',
    title: 'The Student Progress Tracker for Blues Guitar',
    description: 'Track growth lesson by lesson and show parents progress they can hear.',
    value: '$50',
    image: 'https://cdn.magicpatterns.com/uploads/cEdHb7htMdA3DN1cCGKhWY/blues_3.webp',
  },
  {
    number: '04',
    title: 'The Blues Lick Flashcard Vault',
    description: 'Printable lick cards for instant demonstrations, no pen required.',
    value: '$50',
    image: 'https://cdn.magicpatterns.com/uploads/7dGFMCK56Z3Dw2dhiq51tj/blues_4.webp',
  },
  {
    number: '05',
    title: 'The “What To Do When The Student Gets Stuck” Teacher Guide',
    description: 'Proven fixes for every plateau, so no lesson ever stalls again.',
    value: '$50',
    image: 'https://cdn.magicpatterns.com/uploads/8FtdmZusAwiCodCMT61QcM/blues_5.webp',
  },
]

export const checkoutChecklist = [
  '6 complete teaching volumes',
  '5 strategic bonuses',
  '300+ ready-to-teach sessions',
  '120+ visual reference cards',
  'Beginner through stage-ready coverage',
  'Lifetime access to all materials',
]

export const faqs = [
  {
    question: 'Is this digital or physical?',
    answer:
      'Completely digital (PDFs & media) with instant access. Print whatever you need for your students.',
  },
  {
    question: 'Will this work for kids?',
    answer: 'Yes — we include simplified “Big Note” versions for younger students.',
  },
  {
    question: 'Can I use my own logo?',
    answer:
      'Yes. The worksheets are designed for you to brand and use as your own studio materials.',
  },
  {
    question: 'What if it’s not for me?',
    answer: 'Use the 7-day guarantee. No questions asked.',
  },
]

export const comparison = [
  { without: '3+ hours weekly spent planning', with: '5 minutes per week · ready to teach' },
  { without: 'Scavenging for tabs and tracks', with: 'Everything in one organized portal' },
  { without: 'Students quitting out of boredom', with: 'High retention · clear path to mastery' },
  { without: 'Feeling burned out & unprepared', with: 'Feeling like an elite authority' },
]
